import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ImplementKeys } from '@/services/Parameters';

@Module({ name: 'missionReport' })
export default class MissionReportStore extends VuexModule {
  selectedFields: string[] = [];
  selectedMachines: string[] = [];
  selectedPaths: string[] = [];
  selectedMissionTypes: string[] = [ImplementKeys.sprayer, ImplementKeys.tillage];
  selectedToolTypes: string[] = [];
  dates: string[] = [];
  // by default sort newest to oldest
  sortIndex = 'UpdateTimeUTC';
  sortIsDesc: boolean[] = [];
  tablePageNumber = 1;

  @Mutation
  setDateRange(dates: string[]) {
    this.dates = dates;
  }

  @Mutation
  setSelectedFields(fields: string[]) {
    this.selectedFields = fields;
  }

  @Mutation
  setSelectedPaths(paths: string[]) {
    this.selectedPaths = paths;
  }

  @Mutation
  setSelectedMachines(machines: string[]) {
    this.selectedMachines = machines;
  }

  @Mutation
  setSelectedMissionTypes(types: string[]) {
    this.selectedMissionTypes = types;
  }

  @Mutation
  pushSelectedMissionTypes(type: string) {
    this.selectedMissionTypes.push(type);
  }

  @Mutation
  setSelectedToolTypes(types: string[]) {
    this.selectedToolTypes = types;
  }
  @Mutation
  pushSelectedToolTypes(type: string) {
    this.selectedToolTypes.push(type);
  }

  @Mutation
  setTableSort(index: string) {
    this.sortIndex = index;
  }

  @Mutation
  setTableIsDesc(isDesc: boolean[]) {
    this.sortIsDesc = isDesc;
  }

  @Mutation
  setTablePageNumber(page: number) {
    this.tablePageNumber = page;
  }
}
